module.exports = __webpack_public_path__ + "img/5_irene_n.466bb7ac.png";